<template>
  <div class="activity-product-item" @click="onClickProduct($event)">
    <div :class="['product-img', product.website_bkg_img ? 'none-border' : '' ]" :style="{'background-image': 'url(' + product.website_bkg_img + ')'}"></div>
    <div class="product-right">
      <div class="product-name">
        <!-- oss配置时候可以自行设置首页显示标题title -->
        {{product.title || product.product_name}}
      </div>
      <div class="product-info">
        <div class="handle-time">预计办理 {{ product.need_days_shortest === product.need_days_longest ? product.need_days_shortest : `${product.need_days_shortest}-${product.need_days_longest}` }} 工作日</div>
        <div :class="['price', product.special_price ? 'special-price' : '' ]">
          <span class="symbol">￥</span>{{product.special_price ? product.special_price/100 : product.peer_price/100}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    onClickProduct(e) {
      // 不同的位置，需要不同的埋点，因此需要抛到外面处理
      this.$emit('clickProduct', e);
    },
  },
};
</script>

<style lang="less" scoped>
.activity-product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #FFFFFF;
  border-radius: 1px;
  font-size: 14px;
  height: 100px;
  .product-img {
    width: 100px;
    height: 100%;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    border-top: 1px solid #E9EEF2;
    border-bottom: 1px solid #E9EEF2;
    border-left: 1px solid #E9EEF2;
    &.none-border {
      border: none;
    }
  }
  .product-right {
    flex: 1;
    height: 100%;
    padding: 10px 12px;
    border-top: 1px solid #E9EEF2;
    border-bottom: 1px solid #E9EEF2;
    border-right: 1px solid #E9EEF2;
    .product-name {
      color: #2F333D;
      font-weight: 600;
      height: 44px;
      line-height: 22px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .product-info {
      margin-top: 18px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .handle-time {
        font-size: 12px;
        color: #91999F;
        line-height: 12px;
      }
      .price {
        font-weight: 600;
        font-size: 18px;
        color: #FF8033;
        line-height: 18px;
        .symbol {
          font-size: 12px;
          line-height: 14px;
          margin-right: 2px;
        }
        &.special-price {
          position: relative;
          &::after {
            content: '';
            position: absolute;
            display: block;
            width: 29px;
            height: 18px;
            top: -18px;
            right: 0;
            background: url(../../../assets/imgs/index/index-activity/icon-special-top.png) no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activity/index-activity/activity-product-item.vue